import React, { Component } from "react";
import {  withRouter } from "react-router";

import "zrender/lib/svg/svg";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/legend";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import Util from "../../util";
import "./targetProfitHaveCast.css";
import { connect } from "react-redux";
import { getHistoryIncomeList } from "../../action/portfolioAction";

class LineEchart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
    };
  }
  setEchart = (incomeList = [], incomeDateList = []) => {
    if (window.isLess47) {
      var myChart = echarts.init(document.getElementById("SuperLine"));
    } else {
      var myChart = echarts.init(document.getElementById("SuperLine"), null, { renderer: "svg" });
    }
    let dataArr = [];
    myChart.clear();
    myChart.resize();
    myChart.setOption(setLineOption(incomeList, incomeDateList, this.formatter));
    // 默认选中最右一项弹出tooltip
    const timer = setTimeout(() => {
      if (incomeDateList && incomeDateList.length)
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: incomeDateList.length - 1,
        });
      clearTimeout(timer);
    }, 900);
  };
  componentDidMount() {
    const periodType = [1, 3, 6, 12, 36];
    const userAllIncomeHistory = this.props.userAllIncomeHistory[periodType[this.state.tab]] ? this.props.userAllIncomeHistory[periodType[this.state.tab]] : {};
    this.setEchart(userAllIncomeHistory.incomeList, userAllIncomeHistory.incomeDateList);
  }
  shouldComponentUpdate(nextProps = {}, nextState = {}) {
    const thisProps = this.props || {}, thisState = this.state || {};
    for (const key in nextProps) {
      if (thisProps[key] !== nextProps[key] ) {
        return true;
      }
    }
    for (const key in nextState) {
      if (thisState[key] !== nextState[key] ) {
        return true;
      }
    }
    
    return false;
}
  componentWillUpdate(nextProps, nextState) {}
  componentDidUpdate() {
    const periodType = [1, 3, 6, 12, 36];
    const userAllIncomeHistory = this.props.userAllIncomeHistory[periodType[this.state.tab]] ? this.props.userAllIncomeHistory[periodType[this.state.tab]] : {};
    this.setEchart(userAllIncomeHistory.incomeList, userAllIncomeHistory.incomeDateList);
  }
   getColor = (value) => {
    if (!value && value !== 0) return '#333';
    if (value === "--") return "#333";
    if (value >= 0) return "#F8515C";
    return "#1DA96B";
  };
  formatter = (params) => {
    return `<div class="line_echarts_tooltip style_sm_font">累计收益 <span style='margin:0 .1rem'>:</span> <span style='color:${this.getColor(params[0] && params[0].value)}'>${Util.processingDecimal(params[0] && params[0].value,2,true)}</span></div>`;
  };
  render() {
    const { allIncomeLast } = this.props;
    const btn = ["近1月", "近3月", "近6月", "近1年", "近3年"];
    const periodType = [1, 3, 6, 12, 36];
    const dataSource = this.props.userAllIncomeHistory[periodType[this.state.tab]]  ? this.props.userAllIncomeHistory[periodType[this.state.tab]] : {} ;
    const {incomeDateList=[]} = dataSource;

    return (
      <div>
        {incomeDateList.length ?
          <div style={{ position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", position: "absolute", marginBottom: "0.36rem", color: "#3C3C3C", fontSize: ".24rem", lineHeight: ".34rem" }}>
            <div style={{ display: "flex", alignItems: "center"/* , width: "2.5rem"  */}}>
              <i style={{ boxSizing: "content-box", width: ".12rem", height: ".12rem", borderRadius: "50%", border: "2px solid #ffffff", background: "#BF9B79", marginRight: ".1rem" }} />
              累计收益 <span style={{ margin: "0 .1rem" }}>:</span>
              {/* (!allIncomeLast && allIncomeLast !== 0) ? <span style={{color:'#333'}}>--</span> :  */<span style={{color:this.getColor(allIncomeLast)}}>{Util.processingDecimal(allIncomeLast,2,true)}</span>}
            </div>
          </div>
          {/* )} */}
          <div id="SuperLine" style={{ width: "100%", height: 360, overflow: "hidden" }} />
        </div>
        :
        <div style={{display:"flex",flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: ".2rem"}}>
          <div id="SuperLine"/>
       <img style={{width:"4.17rem",height:"2.52rem"}} src={require("../../imgs/iconkongkongruye.png")}/>
       <text style={{fontSize:".28rem",lineHeight:".4rem"}}>这里空空如也～</text>
       </div>
        }
      </div>

    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    userAllIncomeHistory: state.userAllIncomeHistory,
    allIncomeLast: state.allIncomeLast,
  };
}
export default withRouter(connect(mapStateToProps)(LineEchart));

function setLineOption(incomeList = [], incomeDateList = [], formatter) {
  const getColor = (value) => {
    if (!value && value != 0) return;
    if (value === "--") return "#333";
    if (value >= 0) return "#F8515C";
    return "#1DA96B";
  };

  let option = {
    color: ["#BF9B79"],
    grid: {
      left: "0%",
      right: "3%",
      bottom: "3%",
      //top:'3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        color: "#878787",
        fontSize: 9,
        fontWeight: 600,
        axisLine: {
          lineStyle: {
            width: 1,
            color: "#DFDFDF",
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
        axisLabel: {
          color: "#878787",
          align: "center",
          interval: (index, value) => {
            if (index == 0 || index == incomeDateList.length - 1 || index == incomeDateList.length / 2 - 1 || index == (incomeDateList.length - 1) / 2) {
              return value;
            }
            return false;
          },
        
          formatter: (value, index) => {
            if (index == 0) return `{start|${value.split("/").join("-")}}`;
            if (index == incomeDateList.length - 1) return `{end|${value.split("/").join("-")}}`;
            if (index == incomeDateList.length / 2 - 1 || index == (incomeDateList.length - 1) / 2) return `{middle|${value.split("/").join("-")}}`;
          },
          
          rich: {
            start: {
              width: "200%",
              align: "left",
            },
            end: {
              width: "0%",
              align: "right",
            },
            middle: {
              align: "center",
            },
          },
        },
        data: incomeDateList,
      },
    ],
    yAxis: [
      {
        type: "value",
        scale: true,
        // name:'(人)',
        axisLine: {
          lineStyle: {
            width: 0,
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
        axisLabel: {
          formatter: function (value, index) {
            return Util.processingDecimal(value);
          },
        },
        splitLine: {
          lineStyle: {
            color: "#DFDFDF",
            width: 1,
            type: "dotted",
          },
        },
      },
    ],
    animation: window.isLess47,

    tooltip: {
      show: true,
      trigger: "axis",
      alwaysShowContent: true,
      position: [0, 0],
      padding: [0, 0, 0, 0],
      transitionDuration: 0,
      triggerOn:'mousemove|click',
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#48b",
          width: 1,
          type: "dashed",
          opacity: 1,
        },
      },
      backgroundColor: "#FFF",
      extraCssText:'width:100%;',
      formatter: (params) => {
        return formatter(params);
      },
    },
    calculable: true,

    series: [
      {
        name: "累计收益",
        type: "line",
        smooth: true,
        data: incomeList,
        showSymbol:false,
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "rgba(191, 155, 121, 0.15)",
              },
              {
                offset: 1,
                color: "rgba(191, 155, 121, 0)",
              },
            ]),
            origin:'start'
          },
          origin:'start',
        },
      },
    ],
  };

  return option;
}



// WEBPACK FOOTER //
// ./src/components/fundDetail/AllIncomeHaveCastLineEcharts.js